const cameraTemplateJsonData = {
    "mobotix": {

        "cameraname": "$mac$",

        "plate": "$plate$",

        "date": "$date$",

        "utcdate": "$utcdate$",

        "timestamp": "$timestamp$",

        "country": "$countrycode2$",

        "multiplate": "$multiplate$",

        "charheight": "$charheight$",

        "processingtime": "$processingtime$",

        "confidence": "$confidence$",

        "direction": "$direction$",

        "image": "$image$",

        "imagesize": "$imagesize$",

        "plateimage": "$plateimage$",

        "plateimagesize": "$plateimagesize$",

        "messageid": "$uuid$",

        "roi": "$roiid$"
    },

    "milesight": {

        "decodes": [
            {

                "vrm": "$license_plate$",

                "serialNo": "$sn$",

                "mac": "$mac_address$",

                "cameraName": "$device_name$",

                "timestamp": {

                    "time": "$utc_time$",

                    "localTime": "$time$"

                },

                "confidence": "$confidence_int$",

                "motion": "$direction$",

                "plate": "$license_plate_snapshot$",

                "overview": "$full_snapshot$"
            }
        ]
    }
}

export const hasCameraTemplate = (key) => Boolean(cameraTemplateJsonData[key]);

export const formattedCameraTemplate = (key) => JSON.stringify(cameraTemplateJsonData[key], null, 2);